import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { PlanningDayStatusRequest } from "../models/planning/planning-day-status-request";
import { Observable, throwError, TimeoutError } from "rxjs";
import { PlanningDayStatusResponse } from "../models/planning/planning-day-status-response";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { PlanningResultDto } from "../models/planning/planning-result-dto";
import { catchError, takeUntil, timeout } from "rxjs/operators";
import { NotificationType } from "../../core/services/notification-type";

@Injectable()
export class PlanningService extends DataService<any, any> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'planning';
    }

    public checkDayStatus(request: PlanningDayStatusRequest, showNotificationOnError: boolean, cancel$?: Observable<any>): Observable<ActionDataResult<PlanningDayStatusResponse>> {
        let stream = this.postQuery<PlanningDayStatusResponse>(`${this.baseUrl()}/day-status`, request, null, showNotificationOnError)
            .pipe(timeout(60000),
                catchError((errorResponse: any) => {
                    return throwError(errorResponse);
                }));

        stream = stream.pipe(takeUntil(cancel$));

        return stream;
    }

    public checkPlanning(visitDate: Date, customPerformerIntegraCodes: string[] = [], serviceCenterId: number = null, showNotificationOnError: boolean, cancel$?: Observable<any>): Observable<ActionDataResult<PlanningResultDto>> {
        let stream = this.postQuery<PlanningResultDto>(`${this.baseUrl()}/check`, { visitDate: visitDate, performerUserIntegraCodes: customPerformerIntegraCodes, serviceCenterId: serviceCenterId }, null, showNotificationOnError)
            .pipe(timeout(60000),
                catchError((errorResponse: any) => {
                    return throwError(errorResponse);
                }));

        stream = stream.pipe(takeUntil(cancel$));

        return stream;
    }

    public startPlanning(visitDate: Date, customPerformerIntegraCodes: string[] = [], serviceCenterId: number = null, categoryIds: number[] = [], showNotificationOnError: boolean, cancel$?: Observable<any>): Observable<ActionDataResult<PlanningResultDto>> {
        let stream = this.postQuery<PlanningResultDto>(`${this.baseUrl()}/start`, { visitDate: visitDate, performerUserIntegraCodes: customPerformerIntegraCodes, serviceCenterId: serviceCenterId, categoryIds: categoryIds }, null, showNotificationOnError)
            .pipe(timeout(60000),
                catchError((errorResponse: any) => {
                    return throwError(errorResponse);
                }));

        stream = stream.pipe(takeUntil(cancel$));

        return stream;
    }

    public confirmPlanning(result: PlanningResultDto, isAutoPlanning: Boolean): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/confirm-planned-visit`, { result: result, isAutoPlanning: isAutoPlanning });
    }

    public  getAlgoritmType(): Observable<string> {
        return this.getQuery<string>(`${this.baseUrl()}/algoritm-type`);
    }
}